export enum DashboardIds {
  MAIN = 1,
  REQUESTING_PHYSICIAN = 2,
  READING_PHYSICIAN = 3,
  CLINIC_REPRESENTATIVE = 4,
  PATIENT = 5,
  ONE_TIME_ACCESS = 6,
  CROSS_BORDER_AGENCY_CLINIC_REPRESENTATIVE = 7,
}
